/**
 * All new mobile/phone fields must use these helpers for consistent 10-digit validation.
 */
export const MOBILE_VALIDATION_MESSAGE = 'Mobile number must contain exactly 10 digits.';

export function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '').slice(0, 10);
}

export function isValidMobile(value, { required = false } = {}) {
  const digits = digitsOnly(value);
  if (!digits) return !required;
  return digits.length === 10;
}

export function validateMobile(value, { required = false } = {}) {
  const digits = digitsOnly(value);
  if (!digits) {
    return required ? MOBILE_VALIDATION_MESSAGE : null;
  }
  if (digits.length !== 10) {
    return MOBILE_VALIDATION_MESSAGE;
  }
  return null;
}

/** Validate multiple named fields; returns { fieldName: errorMessage } */
export function validateMobileFields(fields, { required = false } = {}) {
  const errors = {};
  Object.entries(fields).forEach(([name, value]) => {
    const err = validateMobile(value, { required });
    if (err) errors[name] = err;
  });
  return errors;
}
